import React, { memo } from 'react';
export const ModulesSection = () => {
  const modules = [{
    num: '1',
    icon: '🧠',
    title: 'Mente Despierta',
    subtitle: 'Actividades cognitivas · Letra grande · Instrucciones claras',
    desc: 'Actividades prácticas de memoria, atención, lenguaje, cálculo cotidiano, asociación y orientación. Una forma simple de proponer momentos de participación sin necesitar formación médica.',
    includes: ['Fichas de actividades cognitivas', 'Propuestas de memoria, atención y lenguaje', 'Cálculo cotidiano, asociación y orientación', 'Instrucciones claras para quien acompaña', 'Espacio de respuesta en cada actividad', 'Registro mensual de participación']
  }, {
    num: '2',
    icon: '🦵',
    title: 'Movilidad Sin Miedo',
    subtitle: 'Movilidad · Fuerza · Equilibrio · Silla o de pie',
    desc: 'Rutinas adaptadas de movilidad, fuerza y equilibrio para realizar en silla o de pie, según las posibilidades del adulto mayor. Incluye indicaciones visuales para acompañar cada propuesta en casa.',
    includes: ['Rutinas en silla para mayor necesidad de acompañamiento', 'Ejercicios de movilidad, fuerza y equilibrio con apoyo', 'Sugerencias para preparar un espacio más seguro', 'Ilustraciones claras de cada posición', 'Progresión gradual según posibilidades', 'Suspender ante dolor, mareos o indicación profesional']
  }, {
    num: '3',
    icon: '🏥',
    title: 'Cuidado Experto',
    subtitle: 'Orientaciones prácticas · Señales de alerta · Cuándo consultar',
    desc: 'Orientaciones generales para organizar el cuidado cotidiano, reconocer señales de alerta y saber cuándo consultar a un profesional. No sustituye diagnósticos, tratamientos, atención de urgencia ni primeros auxilios certificados.',
    includes: ['Orientaciones para la rutina cotidiana', 'Pautas de observación y comunicación', 'Señales de alerta para consultar a un profesional', 'Recordatorios sobre límites del acompañamiento en casa', 'Guía para preparar preguntas para una consulta', 'Recursos que pueden variar según cada localidad']
  }, {
    num: '4',
    icon: '📋',
    title: 'Bitácora de Control 360',
    subtitle: 'Medicación · Presión · Glucemia · Ánimo · Sueño',
    desc: 'Planillas para centralizar información cotidiana: medicación, presión, glucemia, ánimo y sueño. Un registro organizado que puede facilitar la comunicación durante las consultas.',
    includes: ['Ficha personal de información relevante', 'Registro semanal de medicación', 'Planillas de presión y glucemia', 'Registro de ánimo y sueño', 'Espacio para consultas y estudios', 'Formato para completar a mano o digitalmente']
  }, {
    num: '5',
    icon: '⭐',
    title: 'Guía del Cuidador',
    subtitle: 'Organización · Límites · Descanso · Autocuidado · Familia',
    desc: 'Herramientas para organizar tareas, distribuir responsabilidades, crear límites saludables y reconocer señales de sobrecarga. Porque acompañar mejor también implica cuidar a quien cuida.',
    includes: ['Organización de tareas del cuidado diario', 'Cuestionario orientativo de sobrecarga del cuidador', 'Pausas breves y hábitos de autocuidado', 'Mapa familiar para distribuir responsabilidades', 'Plan semanal de descanso y autocuidado', 'Orientaciones para buscar redes de apoyo locales']
  }];
  const inclusions = ['Contenido claro y directo', 'Ilustraciones en cada actividad', 'Instrucciones para familiares y cuidadores', 'Letra grande y legible', 'Registros para completar a mano o digitalmente', 'Material imprimible y reutilizable'];
  return <section id="modulos" className="bg-familia-card py-10 md:py-16 px-4 md:px-6" data-id="element-153">
      <div className="max-w-7xl mx-auto w-[92%] md:w-full" data-id="element-154">
        <div className="text-center mb-10 md:mb-16" data-id="element-155">
          <h2 className="text-[22px] sm:text-3xl md:text-5xl font-display font-bold mb-4 md:mb-6" data-id="element-156">
            📚 LOS 5 MÓDULOS CENTRALES — <br className="hidden sm:block" data-id="element-157" /> Para
            acompañar el cuidado diario con más claridad
          </h2>
          <p className="text-familia-gray text-[15px] md:text-lg max-w-3xl mx-auto leading-relaxed" data-id="element-158">
            Cada módulo reúne actividades, registros y orientaciones prácticas
            para que familias y cuidadores sepan qué hacer, cómo adaptarlo y
            cuándo apoyarse en las indicaciones profesionales.
          </p>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-6 mb-10 md:mb-16" data-id="element-159">
          {modules.map((m, i) => <div key={i} className="bg-familia-section border border-familia-cyan/25 p-6 md:p-8 rounded-2xl card-hover flex flex-col" data-id="element-160">
              <div className="flex items-center justify-between mb-4" data-id="element-161">
                <span className="text-familia-cyan font-mono font-bold text-xs sm:text-sm" data-id="element-162">
                  MÓDULO {m.num}
                </span>
                <span className="text-3xl md:text-4xl" data-id="element-163">{m.icon}</span>
              </div>
              <h3 className="text-lg md:text-xl font-display font-bold mb-1" data-id="element-164">
                {m.title}
              </h3>
              <p className="text-familia-gold text-xs sm:text-sm font-semibold mb-4" data-id="element-165">
                {m.subtitle}
              </p>
              <p className="text-familia-gray text-[14px] md:text-sm leading-relaxed mb-6" data-id="element-166">
                {m.desc}
              </p>
              <div className="border-t border-white/10 pt-4 mt-auto" data-id="element-167">
                <p className="text-xs font-bold text-white/90 uppercase tracking-wider mb-3" data-id="element-168">
                  Incluye:
                </p>
                <ul className="space-y-2" data-id="element-169">
                  {m.includes.map((item, j) => <li key={j} className="flex items-start gap-2 text-[13px] text-familia-gray" data-id="element-170">
                      <span className="text-familia-cyan shrink-0" data-id="element-171">→</span>
                      <span data-id="element-172">{item}</span>
                    </li>)}
                </ul>
              </div>
            </div>)}
        </div>
        <div className="bg-familia-bg border border-familia-cyan/30 border-dashed p-6 md:p-12 rounded-3xl max-w-4xl mx-auto" data-id="element-173">
          <h4 className="text-lg md:text-xl font-display font-bold mb-6 md:mb-8 text-center" data-id="element-174">
            Cada módulo incluye:
          </h4>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 md:gap-x-12 gap-y-3 md:gap-y-4" data-id="element-175">
            {inclusions.map((item, i) => <div key={i} className="flex items-center gap-3 md:gap-4" data-id="element-176">
                <span className="text-familia-green text-lg md:text-xl" data-id="element-177">
                  ✅
                </span>
                <span className="text-[14px] sm:text-base font-medium" data-id="element-178">
                  {item}
                </span>
              </div>)}
          </div>
        </div>
      </div>
    </section>;
};